import React from "react";
import Loader from "./Loader";
import { Outlet, useNavigate } from "react-router";
import { useSelector } from "react-redux";

const PrivateRoutes = () => {
    const { userData, status, error } = useSelector((state) => state.auth);
    const navigate = useNavigate();

    if (!userData || error) {
        return navigate("/");
    } else if (status == 'loading') {
        return <Loader />;
    } else {
        return <Outlet />;
    }
};


export default PrivateRoutes;

